import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import Spinner from 'components/Spinner';
import SVG from 'components/SVG';

import { useIncomeData, useBetsData } from 'features/statistic/model/dashboard/data';
import useModel from 'features/statistic/model/dashboard/useModel';

import formatNumber from 'shared/helpers/formatNumber';
import transfersSVG from 'shared/img/myTransfers.svg';

import DashboardCard from './DashboardCard/DashboardCard';
import DashboardFilter from './DashboardFilter';
import DashboardUsers from './DashboardUsers/DashboardUsers';

import './Dashboard.scss';

const b = block('dashboard-mobile');

const Dashboard = () => {
  const locale = useSelector(state => state.locale.locale.dashboardLocale);
  const { actionProcessing, transfers, bets } = useSelector(state => state.statistic, shallowEqual);
  const { currency } = useSelector(state => state.auth, shallowEqual);

  const model = useModel();

  const incomeElements = useIncomeData().map(item => (
    <div className={b('block-item', { color: item.color })} key={`income_${item.title}`}>
      <SVG svgProps={{ svg: item.icon }} className={b('block-item-icon')} />
      <div className={b('block-item-data')}>
        <div className={b('block-item-text')}>{item.title}</div>
        <div className={b('block-item-value')}>{formatNumber(item.value, 2)}</div>
      </div>
      <div className={b('block-item-currency')}>{currency}</div>
    </div>
  ));

  const betsElements = useBetsData().map(item => (
    <div className={b('block-item', { color: item.color })} key={`income_${item.title}`}>
      <SVG svgProps={{ svg: item.icon }} className={b('block-item-icon')} />
      <div className={b('block-item-data')}>
        <div className={b('block-item-text')}>{item.title}</div>
        <div className={b('block-item-value')}>{formatNumber(item.value, 2)}</div>
      </div>
      <div className={b('block-item-currency')}>{currency}</div>
    </div>
  ));

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <div className={b('title')}>
        <div>{locale.welcomeToPanel}</div>
        <div>{locale.useLeftMenu}</div>
      </div>
      <DashboardCard />
      <DashboardUsers />
      <div className={b('filters')}>
        <DashboardFilter filterState={model} />
      </div>

      <section className={b('block')}>
        <div className={b('block-header')}>
          <div className={b('block-header', 'text')}>{locale.depositAndWithdrawal}</div>
          <div className={b('button')}>
            <Button color="pale" link="/transaction-history">
              <SVG className={b('button-icon')} svgProps={{ svg: transfersSVG }} />
              <div className={b('button-text')}>{locale.allTransfers}</div>
            </Button>
          </div>
        </div>
        {incomeElements}
        <div className={b('block-bottom-item')}>
          <div className={b('block-bottom-item-label')}>{locale.numberOfDeposits}:</div>
          {transfers.depositsCount}
        </div>
        <div className={b('block-bottom-item')}>
          <div className={b('block-bottom-item-label')}>{locale.numberOfWithdrawals}:</div>
          {transfers.withdrawalsCount}
        </div>
      </section>
      <section className={b('block')}>
        <div className={b('block-header')}>
          <div className={b('block-header', 'text')}>{locale.bets}</div>
          <div className={b('button')}>
            <Button color="pale" link="/bet-history">
              <SVG className={b('button-icon')} svgProps={{ svg: transfersSVG }} />
              <div className={b('button-text')}>{locale.betHistory}</div>
            </Button>
          </div>
        </div>
        {betsElements}
        <div className={b('block-bottom-item')}>
          <div className={b('block-bottom-item-label')}>{locale.numberOfBets}:</div>
          {bets.totalBetsCount}
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
